/* eslint-disable prettier/prettier */
export const colors = {
  'Top 10': '#CAF413',
  Crypto: '#13F4A3',
  Honest: '#1DE40B',
  Cheaters: '#FFAB09',
  'Player ACC': '#FF5733',
  Blacklisted: '#39FF14',
  'Low RTP': '#FC2C2C',
  Trusted: '#4A90E2',
  'Average RTP': '#800080',
  New: '#E90EED',
};
